// extracted by mini-css-extract-plugin
module.exports = {"overviewPageLink":"ResourceOverviewPageLink_overviewPageLink__EX0Wk","underline":"ResourceOverviewPageLink_underline__155GS","from":"ResourceOverviewPageLink_from__xKbsc"};